// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46fa55cb","455":"4a894b1e","977":"c34c96f9"}[chunkId] + ".chunk.js";
};